import styled from 'styled-components'
import { Tab } from '@material-ui/core'

export const StyledTab = styled(Tab)`
  height: 48px;
  min-height: 48px;
  & > span {
    display: flex;
    flex-direction: row;
    text-transform: none;
    width: initial;
  }
` as React.ComponentType<any>
